module.exports = __webpack_public_path__ + "img/history-lock.9e9720d9.svg";